import Vue from "vue";
import { WorkerData } from "../interfaces/worker/WorkerData";

export const worker = Vue.observable({
  data: null as WorkerData | null,
});
